<template>
  <v-container fluid style="z-index: 0">
    <v-row v-show="showAnimation">
      <v-col cols="12">
        <v-card max-width="3000" max-height="400" color="primary darken-1">
          <div style="height: 550px;">
            <loading-animation @loopComplete="loadAnimationComplete" />
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-show="!showAnimation" class="align-center justify-center primary darken-1">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="">
        <v-col cols="12">
          <v-icon class="mr-1" size="16">restore</v-icon>
          <span id="update-at-text">Atualizado em {{ data }}</span>
        </v-col>
        <v-card-title class="mb-0">
          <chart-header
            :authorize="authorize"
            @fullscreenChart="fullscreenChart"
            @printChart="printChart"
            @exportChart="exportChart($event)"
            @exportCSV="exportCSV"
            @exportXLS="exportXLS"
            :disableItems="disableItems"
          >
            <template v-slot:title>
              Cotas do reservatório
            </template>
          </chart-header>
        </v-card-title>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="overflow-x: auto">
        <NoData v-if="noData"></NoData>
        <div v-else id="container-chart" style="min-width: 450px; min-height: 350px;"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable */
import Highcharts from "highcharts";
import Accessibility from 'highcharts/modules/accessibility';
import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from "highcharts/modules/offline-exporting";
import LoadingAnimation from "../../common/LoadingAnimation";
import ChartHeader from '../../common/ChartHeader.vue';
import { reservoirSupplyChartAuthorization } from "../../../helpers/chart_export_authorization";
import moment from "moment";
import NoData from "@/components/common/NoData.vue";

Accessibility(Highcharts);
Exporting(Highcharts)
OfflineExporting(Highcharts)

export default {
  components: {
    ChartHeader,
    LoadingAnimation,
    NoData
  },
  props:['reservoirSelected'],
  name: "ReservoirSupplyChart",
  data(){
    return {
      irai: {
        reservoir: require('@/assets/abastecimento-images/irai-reservatorio.svg'),
        barrage: require('@/assets/abastecimento-images/irai-barragem.svg'),
      },
      passauna: {
        reservoir: require('@/assets/abastecimento-images/passauna-reservatorio.svg'),
        barrage: require('@/assets/abastecimento-images/passauna-barragem.svg'),
      },
      piraquara1: {
        reservoir: require('@/assets/abastecimento-images/piraquara1-reservatorio.svg'),
        barrage: require('@/assets/abastecimento-images/piraquara1-barragem.svg'),
      },
      piraquara2: {
        reservoir: require('@/assets/abastecimento-images/piraquara2-reservatorio.svg'),
        barrage: require('@/assets/abastecimento-images/piraquara2-barragem.svg'),
      },
      Miringuava: {
        reservoir: require('@/assets/abastecimento-images/miringuava-reservatorio.svg'),
        barrage: require('@/assets/abastecimento-images/miringuava-barragem.svg'),
      },
      barrage: undefined,
      loading: true,
      showAnimation: false,
      chartRendered: undefined,
      img: undefined,
      img_reservoir: null, // image attribute needs to be global to work (height) in fullscreen
      img_barrage: null, // image attribute needs to be global to work (height) in fullscreen
      data: '##/##/####',
      authorize: [],
      currentUrl: location.toString(),
      host: location.host,
      disableItems: ["PDF"],
      quotas: undefined,
      noData: false,
    }
  },
  watch:{
    reservoirSelected(value){
      if(value){ this.dataSource() }
    },
  },
  mounted() { this.dataSource() },
  methods: {
    loadAnimationComplete(){
      this.showAnimation = this.loading;
    },
    exportChart(typeFile){
      if (typeFile === "application/pdf") {
        this.chartRendered.exportChart({type: typeFile});
      }
      else {
        // exportChartLocal works with PNG/JPEG/SVG!!!!
        this.chartRendered.exportChartLocal({type: typeFile});
      }
    },
    exportCSV(){
      this.chartRendered.downloadCSV();
    },
    exportXLS(){
      this.chartRendered.downloadXLS()
    },
    fullscreenChart(){
      const fullscreenControl = new Highcharts.Fullscreen(this.chartRendered);
      fullscreenControl.open();
    },
    printChart(){
      this.chartRendered.print();
    },
    async dataSource() {
      await this.$store.dispatch('loadQuotas', {
        organization_ids: this.reservoirSelected.orgaoId,
        station_ids: this.reservoirSelected.codigo,
      })
      let quotas = await this.$store.getters.quotas;
      if (quotas.length > 0 && typeof quotas[0].parametros != 'undefined') {
        this.quotas = quotas[0].parametros;
      }
      setTimeout(()=>{
        this.loading = true;
        this.showAnimation = true;
        this.barrage = undefined;
        this.chartPreprocessing();
        this.authorize = reservoirSupplyChartAuthorization;
      }, 50);
    },
    async chartPreprocessing(){

      this.noData = false;

      await this.$store.dispatch('loadCurrentQuotaChart', {
        date_start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        date_end: moment().format('YYYY-MM-DD'),
        operation_ids: 1,
        sensor_ids: 18,
        sort: 'desc',
        station_ids: this.reservoirSelected.codigo,
      })
      let currentQuota = await this.$store.getters.currentQuotaChart;
      currentQuota = currentQuota[0];
      if (currentQuota && typeof currentQuota.data != 'undefined') {
        currentQuota.data = currentQuota.data ? moment(currentQuota.data, 'YYYY-MM-DD').format('DD/MM/YYYY') : "##/##/####"
        this.data = currentQuota.data;
        this.$store.commit('setAlertCota', this.quotas.COTA_ALERTA);
      }
      let chart = document.getElementById('container-chart');
      let series = [];
      let img;
      let y;
      if(this.quotas && this.reservoirSelected.text === 'Iraí'){
        img = this.irai;
        series = [
          { name: 'cota atual', data: [], color: '#45BF55', dashStyle:"ShortDash", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0, id: 'main', },
          { name: 'cota coroamento', type: 'line', data: [this.quotas.COTA_COROAMENTO, this.quotas.COTA_COROAMENTO], color: '#0C6EED', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota máxima maximórum', type: 'line', data: [this.quotas.COTA_MAXIMA_MAXIMORUM, this.quotas.COTA_MAXIMA_MAXIMORUM], color: '#6295E3', dashStyle:"Solid", lineWidth: 3,marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota máxima operacional', type: 'line', data: [this.quotas.COTA_MAXIMA_OPERACIONAL, this.quotas.COTA_MAXIMA_OPERACIONAL], color: '#45CCEA', dashStyle:"Solid", lineWidth: 3,marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota mínima operacional', type: 'line', data: [this.quotas.COTA_MINIMA_OPERACIONAL, this.quotas.COTA_MINIMA_OPERACIONAL], color: '#B57FD9', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota fundo da barragem', type: 'line', data: [this.quotas.COTA_FUNDO_BARRAGEM, this.quotas.COTA_FUNDO_BARRAGEM], color: '#D76767', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: "tomada d'água superior", type: 'line', data: [this.quotas.TOMADA_DAGUA_SUPERIOR, this.quotas.TOMADA_DAGUA_SUPERIOR], visible: false, color: '#A0A0A0', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: "tomada d'água intermediária", type: 'line', data: [this.quotas.TOMADA_DAGUA_INTERMEDIARIA, this.quotas.TOMADA_DAGUA_INTERMEDIARIA], visible: false, color: '#A0A0A0', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: "tomada d'água inferior", type: 'line', data: [this.quotas.TOMADA_DAGUA_INFERIOR, this.quotas.TOMADA_DAGUA_INFERIOR], visible: false, color: '#A0A0A0', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'Dam Barrage', showInLegend: false, xAxis: 1 },
          {
            name: 'cota atual',
            type: 'areaspline',
            linkedTo: 'main',
            dashStyle: 'Dash',
            color: '#45BF55',
            fillColor: 'rgba(68, 170, 213, 0.7)',
            lineWidth: 3,
            data: [currentQuota.valor, currentQuota.valor],
            marker: { enabled: false, radius: undefined },
            xAxis: 0
          },
        ]
        y = { min: series[5].data[0], max: series[1].data[0] }
      } else if(this.reservoirSelected.text === 'Passaúna'){
        img = this.passauna
        series = [
          { name: 'cota atual', data: [], color: '#45BF55', dashStyle:"ShortDash", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0, id: 'main', },
          { name: 'cota coroamento', type: 'line', data: [this.quotas.COTA_COROAMENTO, this.quotas.COTA_COROAMENTO], color: '#0C6EED', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota máxima maximórum', type: 'line', data: [this.quotas.COTA_MAXIMA_MAXIMORUM, this.quotas.COTA_MAXIMA_MAXIMORUM], color: '#6295E3', dashStyle:"Solid", lineWidth: 3,marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota máxima operacional', type: 'line', data: [this.quotas.COTA_MAXIMA_OPERACIONAL, this.quotas.COTA_MAXIMA_OPERACIONAL], color: '#45CCEA', dashStyle:"Solid", lineWidth: 3,marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota mínima operacional', type: 'line', data: [this.quotas.COTA_MINIMA_OPERACIONAL, this.quotas.COTA_MINIMA_OPERACIONAL], color: '#B57FD9', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota fundo da barragem', type: 'line', data: [this.quotas.COTA_FUNDO_BARRAGEM, this.quotas.COTA_FUNDO_BARRAGEM], color: '#D76767', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          {
            name: 'cota atual',
            type: 'areaspline',
            linkedTo: 'main',
            dashStyle: 'Dash',
            color: '#45BF55',
            fillColor: 'rgba(68, 170, 213, 0.7)',
            lineWidth: 3,
            data: [currentQuota.valor, currentQuota.valor],
            marker: { enabled: false, radius: undefined },
            xAxis: 0
          },
        ]
        y = { min: series[5].data[0], max: series[1].data[0] }
      } else if(this.reservoirSelected.text === 'Piraquara I'){
        img = this.piraquara1
        series = [
          { name: 'cota atual', data: [], color: '#45BF55', dashStyle:"ShortDash", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0, id: 'main', },
          { name: 'cota coroamento', type: 'line', data: [this.quotas.COTA_COROAMENTO, this.quotas.COTA_COROAMENTO], color: '#0C6EED', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota máxima maximórum', type: 'line', data: [this.quotas.COTA_MAXIMA_MAXIMORUM, this.quotas.COTA_MAXIMA_MAXIMORUM], color: '#6295E3', dashStyle:"Solid", lineWidth: 3,marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota máxima operacional', type: 'line', data: [this.quotas.COTA_MAXIMA_OPERACIONAL, this.quotas.COTA_MAXIMA_OPERACIONAL], color: '#45CCEA', dashStyle:"Solid", lineWidth: 3,marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota mínima operacional', type: 'line', data: [this.quotas.COTA_MINIMA_OPERACIONAL, this.quotas.COTA_MINIMA_OPERACIONAL], color: '#B57FD9', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota fundo da barragem', type: 'line', data: [this.quotas.COTA_FUNDO_BARRAGEM, this.quotas.COTA_FUNDO_BARRAGEM], color: '#D76767', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          {
            name: 'cota atual',
            type: 'areaspline',
            linkedTo: 'main',
            dashStyle: 'Dash',
            color: '#45BF55',
            fillColor: 'rgba(68, 170, 213, 0.7)',
            lineWidth: 3,
            data: [currentQuota.valor, currentQuota.valor],
            marker: { enabled: false, radius: undefined },
            xAxis: 0
          },
        ]
        y = { min: series[5].data[0], max: series[1].data[0] }
      } else if(this.reservoirSelected.text === 'Piraquara II'){
        img = this.piraquara2
        series = [
          { name: 'cota atual', data: [], color: '#45BF55', dashStyle:"ShortDash", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0, id: 'main', },
          { name: 'cota coroamento', type: 'line', data: [this.quotas.COTA_COROAMENTO, this.quotas.COTA_COROAMENTO], color: '#0C6EED', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota máxima maximórum', type: 'line', data: [this.quotas.COTA_MAXIMA_MAXIMORUM, this.quotas.COTA_MAXIMA_MAXIMORUM], color: '#6295E3', dashStyle:"Solid", lineWidth: 3,marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota máxima operacional', type: 'line', data: [this.quotas.COTA_MAXIMA_OPERACIONAL, this.quotas.COTA_MAXIMA_OPERACIONAL], color: '#45CCEA', dashStyle:"Solid", lineWidth: 3,marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota mínima operacional', type: 'line', data: [this.quotas.COTA_MINIMA_OPERACIONAL, this.quotas.COTA_MINIMA_OPERACIONAL], color: '#B57FD9', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota fundo da barragem', type: 'line', data: [this.quotas.COTA_FUNDO_BARRAGEM, this.quotas.COTA_FUNDO_BARRAGEM], color: '#D76767', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: "tomada d'água superior", type: 'line', data: [this.quotas.TOMADA_DAGUA_SUPERIOR, this.quotas.TOMADA_DAGUA_SUPERIOR], visible: false, color: '#A0A0A0', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: "tomada d'água intermediária", type: 'line', data: [this.quotas.TOMADA_DAGUA_INTERMEDIARIA, this.quotas.TOMADA_DAGUA_INTERMEDIARIA], visible: false, color: '#A0A0A0', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: "tomada d'água inferior", type: 'line', data: [this.quotas.TOMADA_DAGUA_INFERIOR, this.quotas.TOMADA_DAGUA_INFERIOR], visible: false, color: '#A0A0A0', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          {
            name: 'cota atual',
            type: 'areaspline',
            linkedTo: 'main',
            dashStyle: 'Dash',
            color: '#45BF55',
            fillColor: 'rgba(68, 170, 213, 0.7)',
            lineWidth: 3,
            data: [currentQuota.valor, currentQuota.valor],
            marker: { enabled: false, radius: undefined },
            xAxis: 0
          },
        ]
        y = { min: series[5].data[0], max: series[1].data[0] }
      } else if (this.reservoirSelected.text === 'Miringuava') {
        img = this.Miringuava
        series = [
          { name: 'cota atual', data: [], color: '#45BF55', dashStyle:"ShortDash", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0, id: 'main', },
          { name: 'cota coroamento', type: 'line', data: [this.quotas.COTA_COROAMENTO, this.quotas.COTA_COROAMENTO], color: '#0C6EED', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota máxima maximórum', type: 'line', data: [this.quotas.COTA_MAXIMA_MAXIMORUM, this.quotas.COTA_MAXIMA_MAXIMORUM], color: '#6295E3', dashStyle:"Solid", lineWidth: 3,marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota máxima operacional', type: 'line', data: [this.quotas.COTA_MAXIMA_OPERACIONAL, this.quotas.COTA_MAXIMA_OPERACIONAL], color: '#45CCEA', dashStyle:"Solid", lineWidth: 3,marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota mínima operacional', type: 'line', data: [this.quotas.COTA_MINIMA_OPERACIONAL, this.quotas.COTA_MINIMA_OPERACIONAL], color: '#B57FD9', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: 'cota fundo da barragem', type: 'line', data: [this.quotas.COTA_FUNDO_BARRAGEM, this.quotas.COTA_FUNDO_BARRAGEM], color: '#D76767', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: "tomada d'água superior", type: 'line', data: [this.quotas.TOMADA_DAGUA_SUPERIOR, this.quotas.TOMADA_DAGUA_SUPERIOR], visible: false, color: '#A0A0A0', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: "tomada d'água intermediária superior", type: 'line', data: [this.quotas.TOMADA_DAGUA_INTERMEDIARIA_SUPERIOR, this.quotas.TOMADA_DAGUA_INTERMEDIARIA_SUPERIOR], visible: false, color: '#A0A0A0', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          { name: "tomada d'água intermediária inferior", type: 'line', data: [this.quotas.TOMADA_DAGUA_INTERMEDIARIA_INFERIOR, this.quotas.TOMADA_DAGUA_INTERMEDIARIA_INFERIOR], visible: false, color: '#A0A0A0', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
           { name: "tomada d'água inferior", type: 'line', data: [this.quotas.TOMADA_DAGUA_INFERIOR, this.quotas.TOMADA_DAGUA_INFERIOR], visible: false, color: '#A0A0A0', dashStyle:"Solid", lineWidth: 3, marker: { enabled: false, radius: undefined }, xAxis: 0 },
          {
            name: 'cota atual',
            type: 'areaspline',
            linkedTo: 'main',
            dashStyle: 'Dash',
            color: '#45BF55',
            fillColor: 'rgba(68, 170, 213, 0.7)',
            lineWidth: 3,
            data: [currentQuota.valor, currentQuota.valor],
            marker: { enabled: false, radius: undefined },
            xAxis: 0
          },
        ]
        y = { min: series[5].data[0], max: series[1].data[0] }
      }
      this.img = img;
      if(series, img, y){
        await this.charts(series, img, y)
        this.loading = false
        chart.style.visibility = 'visible'
        chart.style.display = 'block'
      } else {
        chart.style.visibility = 'hidden'
        chart.style.display = 'none'
      }
    },
    async charts(series, img, y){
      Highcharts.setOptions({
        lang: {
          months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
          shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
          weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        }
      })

      const this_ = this;
      this.chartRendered = Highcharts.chart('container-chart', {
        chart: {
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
          events: {
            load: function () {
              // if(this.options.chart.forExport) {}
              const protocol = this_.currentUrl.split("://")[0];
              const base_url = protocol + "://" + this_.host;
              this.img_reservoir = this.renderer.image(base_url + img.reservoir, 0, this.plotTop, "78%", this.plotBox.height).add();
              this.img_barrage = this.renderer.image(base_url + img.barrage, "78%", this.plotTop, "78%", this.plotBox.height).add();

              // Force set x and width
              this.img_reservoir.attr({x: "0", width: "78%"});
              this.img_barrage.attr({x: "78%", width: "78%"});
            },
            redraw: function () {
              this.img_reservoir.attr({height: this.plotBox.height, y: this.plotTop});
              this.img_barrage.attr({height: this.plotBox.height, y: this.plotTop});
            },
          }
        },
        title: { text: null },
        subtitle: { text: null },
        exporting: {
          enabled: false,
          filename: this.reservoirSelected.text,
          chartOptions: {
            title: {
              text: this.reservoirSelected.text,
              style: {
                color: '#FFFFFF'
              }
            },
          },
          fallbackToExportServer: false,
        },
        credits: {
          enabled: true,
          href: 'http://www.simepar.br/',
          text:'by: SIMEPAR',
          style:{ color: '#FFFFFF'}
        },
        yAxis: {
          min: y.min,
          max: y.max,
          tickInterval: 1,
          endOnTick: false,
          startOnTick: false,
          gridLineWidth: 0,
          title: {
            text: 'Reservatório (m)',
            style:{ color: '#FFFFFF'}
          },
          accessibility:{
            description: 'Reservatório (m)',
          },
          labels: {
            style: {
              color: '#FFFFFF'
            }
          },
        },
        xAxis: [
          {
            width: '78%',
            labels: {
              enabled: false
            }
          },
          {
            offset: 0,
            left: '78%',
            width: '22%',
            labels: {
              enabled: false
            },
          }
        ],
        legend: {
          enabled: true,
          itemStyle:{
            color: '#FFFFFF',
          },
          itemHoverStyle: {
            color: '#979797'
          }
        },
        tooltip: {
          crosshairs: false,
          shared: true, //shared(true) or single(false) ?
          enabled: true,
          headerFormat: '',
          pointFormat: '<b style="color:{series.color}">{series.name}</b> : <b>{point.y:,.3f} m</b><br/>',
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: true
            },
          }
        },
        series: [...series],
        caption:{
          text: 'Gráfico de Cotas do reservatório',
          style: { color: '#FFFFFF'},
        },
      });
    },
  },
}
</script>
<style scoped>
#update-at-text{
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
}
</style>
